/**
 * @public
 */
export var TeamsTheme;
(function (TeamsTheme) {
    TeamsTheme["HighContrast"] = "teamsHighContrastTheme";
    TeamsTheme["Dark"] = "teamsDarkTheme";
    TeamsTheme["Default"] = "teamsTheme";
})(TeamsTheme || (TeamsTheme = {}));
//# sourceMappingURL=constants.js.map